export default class SharedJwtServices {
  axiosIns = null

  jwtConfig = null

  // customAxios = axios.create({
  //   baseURL: trimEnd(process.env.VUE_APP_SERVER_URL, 'admin/'),
  // })

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  /** Countries */
  fetchCountries(params) {
    return this.axiosIns.get('/countries', { params })
  }

  fetchGeoData(params) {
    return this.axiosIns.get('/geo-data', { params })
  }

  fetchChurchRegions() {
    return this.axiosIns.get('/regions', {})
  }

  fetchMemberStatus() {
    return this.axiosIns.get('/shared/member-status', {})
  }

  fetchChurchAreas(region_id) {
    return this.axiosIns.get(`/areas`, { params: { region_id } })
  }

  fetchChurchDistricts(region, area) {
    return this.axiosIns.get(`/regions/${region}/areas/${area}/districts`, {})
  }

  fetchChurchAssemblies(region, area, district) {
    return this.axiosIns.get(`/regions/${region}/areas/${area}/districts/${district}/assemblies`, {})
  }

  getReservationReceipt(reservation_id) {
    return this.axiosIns.get(`/qr/${reservation_id}`, {})
  }

  fetchMemberTypes(params) {
    return this.axiosIns.get('/shared/member-types', { params })
  }

  fetchMemberTitles(params) {
    return this.axiosIns.get('/shared/member-titles', { params })
  }

  fetchMemberDesignations(params) {
    return this.axiosIns.get('/shared/member-designations', { params })
  }

  fetchDepartments() {
    return this.axiosIns.get('/shared/departments')
  }


  // geo endpoints
  fetchGeoRegions(params = {}) {
    return this.axiosIns.get('/geo/regions', { params })
  }

  exportGeoRegions(params = {}) {
    return this.axiosIns.get('/geo/regions/export', { params, responseType: "blob" })
  }

  updateGeoRegionStatus(id, is_active) {
    return this.axiosIns.put(`/geo/regions/${id}/status`, { is_active })
  }

  updateGeoRegion(id, data) {
    return this.axiosIns.put(`/geo/regions/${id}`, data)
  }

  deleteGeoRegion(id) {
    return this.axiosIns.delete(`/geo/regions/${id}`)
  }

  createGeoRegion(data) {
    return this.axiosIns.post(`/geo/regions`, data)
  }

  fetchGeoAreas(params = {}) {
    return this.axiosIns.get('/geo/areas', { params })
  }

  exportGeoAreas(params = {}) {
    return this.axiosIns.get('/geo/areas/export', { params, responseType: "blob" })
  }

  getGeoArea(id) {
    return this.axiosIns.get(`/geo/areas/${id}`)
  }

  updateGeoArea(id, data) {
    return this.axiosIns.put(`/geo/areas/${id}`, data)
  }

  deleteGeoArea(id) {
    return this.axiosIns.delete(`/geo/areas/${id}`)
  }

  createGeoArea(data) {
    return this.axiosIns.post(`/geo/areas`, data)
  }

  updateGeoAreaStatus(id, is_active) {
    return this.axiosIns.put(`/geo/areas/${id}/status`, { is_active })
  }

  fetchGeoDistricts(params = {}) {
    return this.axiosIns.get('/geo/districts', { params })
  }

  exportGeoDistricts(params = {}) {
    return this.axiosIns.get('/geo/districts/export', { params, responseType: "blob" })
  }

  getGeoDistrict(id) {
    return this.axiosIns.get(`/geo/districts/${id}`)
  }

  updateGeoDistrict(id, data) {
    return this.axiosIns.put(`/geo/districts/${id}`, data)
  }

  deleteGeoDistrict(id) {
    return this.axiosIns.delete(`/geo/districts/${id}`)
  }

  createGeoDistrict(data) {
    return this.axiosIns.post(`/geo/districts`, data)
  }

  updateGeoDistrictStatus(id, is_active) {
    return this.axiosIns.put(`/geo/districts/${id}/status`, { is_active })
  }

  fetchGeoAssemblies(params = {}) {
    return this.axiosIns.get('/geo/assemblies', { params })
  }

  exportGeoAssemblies(params = {}) {
    return this.axiosIns.get('/geo/assemblies/export', { params, responseType: "blob" })
  }

  updateGeoAssemblies(id, data) {
    return this.axiosIns.put(`/geo/assemblies/${id}`, data)
  }

  deleteGeoAssemblies(id) {
    return this.axiosIns.delete(`/geo/assemblies/${id}`)
  }

  createGeoAssemblies(data) {
    return this.axiosIns.post(`/geo/assemblies`, data)
  }

  updateGeoAssemblyStatus(id, is_active) {
    return this.axiosIns.put(`/geo/assemblies/${id}/status`, { is_active })
  }

  // mission blocks
  fetchMissionBlocks(params = {}) {
    return this.axiosIns.get('/mission-blocks', { params })
  }

  getMissionBlock(id) {
    return this.axiosIns.get(`/mission-blocks/${id}`)
  }

  createMissionBlock(data) {
    return this.axiosIns.post('/mission-blocks', data)
  }

  updateMissionBlock(id, data) {
    return this.axiosIns.put(`/mission-blocks/${id}`, data)
  }

  deleteMissionBlock(id) {
    return this.axiosIns.delete(`/mission-blocks/${id}`)
  }

  // rmc (Regional Missions Council)
  fetchRmc(params = {}) {
    return this.axiosIns.get('/geo/rmc', { params })
  }

  exportRmc(params = {}) {
    return this.axiosIns.get('/geo/rmc/export', { params, responseType: "blob" })
  }

  getRmc(id) {
    return this.axiosIns.get(`/geo/rmc/${id}`)
  }

  createRmc(data) {
    return this.axiosIns.post('/geo/rmc', data)
  }

  updateRmc(id, data) {
    return this.axiosIns.put(`/geo/rmc/${id}`, data)
  }

  deleteRmc(id) {
    return this.axiosIns.delete(`/geo/rmc/${id}`)
  }

  // countries (managed via geo/countries; the plain /countries lookup above stays read-only)
  fetchGeoCountries(params = {}) {
    return this.axiosIns.get('/geo/countries', { params })
  }

  exportGeoCountries(params = {}) {
    return this.axiosIns.get('/geo/countries/export', { params, responseType: "blob" })
  }

  getGeoCountry(id) {
    return this.axiosIns.get(`/geo/countries/${id}`)
  }

  createGeoCountry(data) {
    return this.axiosIns.post('/geo/countries', data)
  }

  updateGeoCountry(id, data) {
    return this.axiosIns.put(`/geo/countries/${id}`, data)
  }

  deleteGeoCountry(id) {
    return this.axiosIns.delete(`/geo/countries/${id}`)
  }

  updateGeoCountryStatus(id, is_active) {
    return this.axiosIns.put(`/geo/countries/${id}/status`, { is_active })
  }

  bulkUpdateGeoCountriesSupported(ids, supported) {
    return this.axiosIns.post(`/geo/countries/bulk`, { ids, supported })
  }
}

